import React from 'react';
import { StaffMembersDataHooks } from './dataHooks';
import { TagName } from '../../../../utils/tagName.const';
import { StaffMember } from '@wix/bookings-uou-types';
import Text, { TextType } from '../../Text/Text';
import { TFunction, useTranslation } from '@wix/yoshi-flow-editor';
import { FormService } from '../../../../utils/mappers/serviceMapper/service.mapper';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import {
  ResourceSelection,
  SelectionMethod,
} from '@wix/ambassador-bookings-v2-booking/types';

export interface StaffMembersProps {
  service: FormService;
  resourceSelections?: ResourceSelection[];
}

const StaffMembers: React.FC<StaffMembersProps> = ({
  service,
  resourceSelections,
}) => {
  const { t } = useTranslation();
  const staffMemberNames = getStaffMembers(service, t, resourceSelections);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={StaffMembersDataHooks.STAFF_MEMBER}
      tagName={TagName.Paragraph}
    >
      {staffMemberNames}
    </Text>
  );
};

const getStaffMembers = (
  service: FormService,
  t: TFunction,
  resourceSelections?: ResourceSelection[],
) => {
  const staffMembers: StaffMember[] = service.staffMembers || [];
  // TODO: Remove the else when the deprecated the experiment specs.bookings.BookFlowSettings
  if (resourceSelections?.[0]?.selectionMethod) {
    if (staffMembers.length || service.type !== ServiceType.APPOINTMENT) {
      return staffMembers.map((staffMember) => staffMember.name).join(', ');
    }
    if (
      resourceSelections?.[0]?.selectionMethod === SelectionMethod.ANY_RESOURCE
    ) {
      return t('app.bookings-form.appointment-details.first-available');
    }
    return '';
  } else {
    if (staffMembers.length || service.type !== ServiceType.APPOINTMENT) {
      return staffMembers.map((staffMember) => staffMember.name).join(', ');
    }
    return t('app.bookings-form.appointment-details.first-available');
  }
};

export default StaffMembers;
